import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { PiArrowUpRight, PiArrowDownRight } from "react-icons/pi";
import styles from "./Counter.module.css";

const Counter = ({ icon, change, title, number }) => {
  const isPositive = change > 0;

  return (
    <Box className={styles.counter}>
      <Box className={styles.iconcontentWrapper}>
        {icon && (
          <Box className={styles.iconWrapper}>
            <Box className={styles.iconCircle}>
              <Box className={styles.icon}>{icon}</Box>
            </Box>
          </Box>
        )}
        <Box className={styles.content}>
          <Typography className={styles.number}>{number}</Typography>
          <Typography className={styles.title}>{title}</Typography>
        </Box>
      </Box>
      {change !== undefined && (
        <Box className={styles.changeWrapper}>
          <Typography className={styles.change}>
            {change > 0 ? `+${change}%` : `${change}%`}
          </Typography>
          {isPositive ? (
            <PiArrowUpRight className={`${styles.changeIcon} ${styles.positive}`} />
          ) : (
            <PiArrowDownRight className={`${styles.changeIcon} ${styles.negative}`} />
          )}
        </Box>
      )}
    </Box>
  );
};

Counter.propTypes = {
  icon: PropTypes.node,
  change: PropTypes.number,
  title: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
};

export default Counter;